import styled from 'styled-components'

import { ILiveDataProvider } from '@/app/2023/consejo/providers/LiveDataProvider'
import { useEnvironment } from '@/app/providers/EnvironmentProvider'
import { colors, spaces } from '@/config/global-parameters'

export interface IProgressEpigraph {
  className?: string
  updatedAt?: Date
}

const ProgressEpigraph = ({ className, updatedAt }: IProgressEpigraph) => {
  const { liveData } = useEnvironment<ILiveDataProvider>()
  const { mesasEscrutadas } = liveData

  const time = updatedAt
    ? new Intl.DateTimeFormat('es-ES', {
      hour: 'numeric',
      hour12: false,
      minute: 'numeric',
      timeZone: 'America/Toronto',
    })
      .format(updatedAt)
    : ''

  const day = updatedAt
    ? new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      timeZone: 'America/Toronto',
    })
      .format(updatedAt)
    : ''

  const month = updatedAt
    ? new Intl.DateTimeFormat('es-ES', {
      month: 'short',
      timeZone: 'America/Toronto',
    })
      .format(updatedAt)
    : ''

  const p = mesasEscrutadas && mesasEscrutadas[mesasEscrutadas.length - 1]
  const message = `Última actualización a las ${time} el ${day} ${month} con el ${
    p ? p.porcentaje_mesas_gen : 0
  }% de las mesas escrutadas`

  return <Epigraph className={className}>{message}</Epigraph>
}

export const Epigraph = styled.span`
  display: flex;
  font-size: 12px;
  justify-content: center;
  align-items: center;
  color: ${colors.colorGrey3};
  text-transform: uppercase;
  text-align: center;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    font-size: 10px;
  }
`

export default ProgressEpigraph
